import type { SortState } from '../lib/sorting';
import { Icon } from './Icon';

/**
 * A column heading that sorts by itself.
 *
 * The arrow only appears on the column actually in use: six arrows in a row is
 * decoration, one is an answer to "what am I looking at?". `aria-sort` says
 * the same thing to a screen reader, which is the only way it is said there.
 */
export function SortHeader<Key extends string>({
  label,
  column,
  sort,
  onSort,
  numeric,
}: {
  label: string;
  column: Key;
  sort: SortState<Key>;
  onSort: (key: Key) => void;
  /** Right-aligned columns keep their arrow on the inside edge. */
  numeric?: boolean;
}) {
  const on = sort.key === column;
  return (
    <th
      className={numeric ? 'num' : undefined}
      aria-sort={on ? (sort.direction === 'asc' ? 'ascending' : 'descending') : 'none'}
    >
      <button
        type="button"
        className={`sorter ${on ? 'sorter--on' : ''}`}
        onClick={() => onSort(column)}
      >
        {label}
        <span className="sorter__arrow" aria-hidden="true">
          {on && <Icon name={sort.direction === 'asc' ? 'chevronUp' : 'chevronDown'} size={14} />}
        </span>
      </button>
    </th>
  );
}
